import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Text } from "components";
import { RouteConstants } from "constant";
import useDashboardChats from "pages/dashboard/shared/useDashboardChats";

import classes from "./MessagesWidgetSection.module.css";

interface MessagesWidgetSectionProps {
  className?: string;
}

const { ROUTE_CHAT } = RouteConstants;

const MessagesWidgetSection = ({ className }: MessagesWidgetSectionProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { unreadMessagesCount } = useDashboardChats();

  return (
    <section className={[classes.root, className].filter(Boolean).join(" ")}>
      <Text className={classes.title}>{t("header.chat")}</Text>
      <div className={classes.body}>
        <button
          type="button"
          className={classes.badge}
          onClick={() => navigate(ROUTE_CHAT)}
          aria-label={t("header.chat")}
        >
          <Text className={classes.badgeText}>{unreadMessagesCount}</Text>
        </button>
      </div>
    </section>
  );
};

export default MessagesWidgetSection;
